var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRecontact = function SvgRecontact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2935"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2934"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6129",
    d: "M10.35 47.998a6.5 6.5 0 0 1-6.5-6.5V12.123h62.433a6.5 6.5 0 0 1 6.5 6.5 6.5 6.5 0 0 1-6.5 6.5H16.85v16.375a6.5 6.5 0 0 1-6.5 6.5Z",
    fill: "#39F"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6130",
    d: "M69.65 34.358a6.5 6.5 0 0 1 6.5 6.5v29.141H13.717a6.5 6.5 0 0 1-6.5-6.5 6.5 6.5 0 0 1 6.5-6.5H63.15V40.858a6.5 6.5 0 0 1 6.5-6.5Z",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6128",
    d: "M61.029 32.245a4.982 4.982 0 0 1-3.535-1.465 5 5 0 0 1 0-7.07l5.086-5.088-5.086-5.086a5 5 0 0 1 0-7.07 5 5 0 0 1 7.071 0l12.158 12.156L64.565 30.78a4.983 4.983 0 0 1-3.536 1.465Z",
    fill: "#39F"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6131",
    d: "M18.971 49.878a4.984 4.984 0 0 1 3.536 1.464 5 5 0 0 1 0 7.071l-5.087 5.088 5.087 5.085a5 5 0 0 1 0 7.071 5 5 0 0 1-7.071 0L3.278 63.501l12.158-12.158a4.985 4.985 0 0 1 3.535-1.465Z",
    fill: "#707070"
  })))));
};
export default SvgRecontact;